import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'localizedMonth',
  pure: false
})
export class LocalizedMonthPipe implements PipeTransform {
  private readonly monthKeys: Record<string, string> = {
    january: 'date.months.january',
    february: 'date.months.february',
    march: 'date.months.march',
    april: 'date.months.april',
    may: 'date.months.may',
    june: 'date.months.june',
    july: 'date.months.july',
    august: 'date.months.august',
    september: 'date.months.september',
    october: 'date.months.october',
    november: 'date.months.november',
    december: 'date.months.december'
  };

  private readonly monthAbbrToFullKey: Record<string, string> = {
    jan: 'date.months.january',
    feb: 'date.months.february',
    mar: 'date.months.march',
    apr: 'date.months.april',
    may: 'date.months.may',
    jun: 'date.months.june',
    jul: 'date.months.july',
    aug: 'date.months.august',
    sep: 'date.months.september',
    sept: 'date.months.september',
    oct: 'date.months.october',
    nov: 'date.months.november',
    dec: 'date.months.december'
  };

  constructor(private readonly translate: TranslateService) {}

  transform(value: string | null | undefined): string {
    if (!value) return '';

    let result = value.replace(
      /\bWeek of\b/g,
      () => this.translate.instant('date.week_of')
    );

    result = result.replace(
      /\b(January|February|March|April|May|June|July|August|September|October|November|December)\b/g,
      month => this.translate.instant(this.monthKeys[month.toLowerCase()] ?? month)
    );

    result = result.replace(
      /\b(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Sept|Oct|Nov|Dec)\b\.?/g,
      abbr => {
        const key = abbr.replace(/\.$/, '').toLowerCase();
        const fullKey = this.monthAbbrToFullKey[key];
        return fullKey ? this.translate.instant(fullKey) : abbr;
      }
    );

    return result;
  }
}
